import { render, staticRenderFns } from "./contact_us.vue?vue&type=template&id=5b98c78f&scoped=true&"
import script from "./contact_us.vue?vue&type=script&lang=js&"
export * from "./contact_us.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b98c78f",
  null
  
)

export default component.exports